import { TextAlign } from './TextAlign';

export { TextAlign };



// WEBPACK FOOTER //
// ./src/baseComponents/directives/TextAlign/index.js